module.exports = __webpack_public_path__ + "static/media/text_2.b2195f9e.png";